import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocationService } from '../location.service';
import { SearchCountryMasterComponent } from './search-country-master/search-country-master.component';

@Component({
  selector: 'app-country-master',
  templateUrl: './country-master.component.html',
  styleUrls: ['./country-master.component.scss']
})
export class CountryMasterComponent implements OnInit {
  countryForm: FormGroup;
  SavingPayLoad: any;
  public selectCountryObj: any = {};
  selectedCountryId: number;
  popbutton:number;
  enabledisablebtn:boolean =false;
  getdatacountry: any;
  constructor(public dialog: MatDialog, private _fb: FormBuilder, public locationService: LocationService ,public dialogRef: MatDialogRef<CountryMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.enabledisablebtn=true;
    this.popbutton =0;
    if(this.data.id !=null && this.data.id !=undefined){
      this.popbutton =this.data.id;
    }
    this.loadCountryForm();
    this.getCountryList();
  }
  closedailog(){
    this.dialogRef.close();
  }
  loadCountryForm() {
    this.enabledisablebtn=true;
    this.countryForm = this._fb.group({
      pkCountryId: ' ',
      countryName: ['', [Validators.required]],
      countryCode: ['', [Validators.required]],
      mobileLength: ['', [Validators.required]],
      pincodeLength:['', [Validators.required]],
      isActive: false,
      pK_SynchId: ''
    });
  }
  enableButton($event){    
    const form = this.countryForm.controls;
    if(form.countryName.value == '' || form.countryCode.value == '' ||  form.countryCode.value == null ||  
      form.countryCode.value == undefined || form.countryName.value == null || form.countryName.value == undefined ||
      form.mobileLength.value == '' ||  form.mobileLength.value == null ||  
      form.mobileLength.value == undefined ||form.pincodeLength.value == '' ||  form.pincodeLength.value == null ||  
      form.pincodeLength.value == undefined 
    ){
      this.enabledisablebtn= true;
    }else{
      this.enabledisablebtn=false;
    }
  }
  getCountryList() {
    this.locationService.getCountry().subscribe(data => {
      this.getdatacountry = data
    });
  }
  /** Save and Update Country Form */
  saveCountryForm(event) {   
     const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);
    const form = this.countryForm.controls;
    console.log(form , "form::::::::::::;;;");
    if (form.mobileLength.value < 10 || form.mobileLength.value > 15) {
      this.locationService.openSnackBar("Mobile Number Length must be between 10 and 15", "OK");
      return;
    }  
   
    if (form.pincodeLength.value < 4 || form.pincodeLength.value > 10) {
      this.locationService.openSnackBar("Pincode Length must be between 4 and 10", "OK");
      return; 
    }
    if (form.pkCountryId.value === ' ') {
       var countrynameData = this.getdatacountry.filter(item =>item.countryName == form.countryName.value);
       var countryCodeData = this.getdatacountry.filter(item =>item.countryCode == form.countryCode.value);
       if(countrynameData.length >0 || countryCodeData.length >0){      
        this.locationService.openSnackBar("Already Exists in  list" , "OK");
        this.loadCountryForm();
        return 
       }
      this.SavingPayLoad = {
      CountryName: form.countryName.value,
      CountryCode: form.countryCode.value,
      IsActive: form.isActive.value,
      PkCountryId: 0,
      MobLength: form.mobileLength.value,
      PinCodeLength: form.pincodeLength.value,
      IsEdit: false,
     }

      this.locationService.addCountryMaster(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {        
          this.locationService.openSnackBar("Record Saved Successfully ", "OK");
          this.loadCountryForm();
          this.getCountryList();
        }
      },
      err => {
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
      }
    );
    }else{
      this.SavingPayLoad = {
        CountryName: form.countryName.value,
        CountryCode: form.countryCode.value,
        IsActive: form.isActive.value,
        PkCountryId: form.pkCountryId.value,
        MobLength: form.mobileLength.value,
        PinCodeLength: form.pincodeLength.value,
      }
      this.locationService.addCountryMaster(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {          
          this.locationService.openSnackBar("Record Updated Successfully " , "OK");
          this.loadCountryForm();
          this.getCountryList();
        }
      },
      err => {
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
      }
    );
    }

  }

  /** Seach Country Master */
  searchCountryMaster() {
    const dialogRef1 = this.dialog.open(SearchCountryMasterComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "450px",
      width: "50%",
    });

    dialogRef1.afterClosed().subscribe(result => {
      this.selectCountryObj = this.locationService.selecteCountryData
      if (this.selectCountryObj != null) {
        this.enabledisablebtn=false;
        this.selectedCountryId = this.selectCountryObj.pkCountryId;
        this.setupdateCountryForm(this.selectedCountryId);
      }
    });
  }

  setupdateCountryForm(stateId) {
    this.locationService.getCountryItem(stateId).subscribe(data => {
      let selectedCountrydata = data[0];
      this.countryForm.patchValue(
        {
          countryName: selectedCountrydata.countryName,
          countryCode: selectedCountrydata.countryCode,
          isActive: selectedCountrydata.isActive,
          pkCountryId: selectedCountrydata.pkCountryId,
          mobileLength: selectedCountrydata.mobLength,
          pincodeLength: selectedCountrydata.pinCodeLength
        });
        this.enableButton(event)
    });
  }
}
